import { Radio } from '@ifood/pomodoro-components';
import styled from 'styled-components';

export const PomodoroButton = styled(Radio.Button)`
  display: flex;

  label {
    cursor: pointer;
  }
`;
